import createCache from "./createCache";
import { getApolloSharedCaches } from "../../shared/apollo/getApolloSharedCaches";
export function getCache(schemas, sharedCache, sharedCacheId) {
    if (sharedCache && sharedCacheId) {
        throw new Error('Cannot specify both sharedCache and sharedCacheId');
    }
    if (sharedCache) {
        return sharedCache;
    }
    const sharedApolloCaches = getApolloSharedCaches();
    if (sharedCacheId) {
        const existingCache = sharedApolloCaches.get(sharedCacheId);
        if (existingCache) {
            return existingCache;
        }
    }
    const cache = createCache(schemas);
    if (sharedCacheId) {
        sharedApolloCaches.set(sharedCacheId, cache);
    }
    return cache;
}

//# sourceMappingURL=getCache.js.map